package com.milta.core.localization.translations.ro

import com.milta.core.localization.LoadingAddressStrings

internal val LoadingAddress = LoadingAddressStrings(
    title = "Adresă de încărcare",
    emptyMessage = "Pentru a optimiza cursa, indicați unde încarcă șoferii dumneavoastră marfa. Adresa va fi salvată pentru cursele următoare.",
    selectPlaceholder = "Alegeți o adresă de încărcare",
    sheetSubtitle = "Locul unde șoferii dumneavoastră preiau marfa.",
    startPointBadge = "Punct de plecare",
    newAddressAction = "Adresă nouă",
    mobileSearchPlaceholder = "Stradă, număr, localitate",
    webSearchPlaceholder = "Căutați o adresă…",
    deleteDialogTitle = "Ștergeți această adresă?",
    deleteDialogMessage = "„%s” nu va mai fi propusă. Cursele deja create nu se modifică.",
    webSubmitBlockedHint = "Alegeți o adresă de încărcare pentru a optimiza.",
    errorRequired = "Alegeți o adresă de încărcare.",
)
